import { useRef } from "react";

/**
 * `useId` stand-in for React 17.
 *
 * The planner form associates labels with a custom listbox through
 * `aria-labelledby`, which needs a stable unique id per field. React 18's
 * `useId` does that; this project is on React 17, so the id comes from a module
 * counter instead. There is no server render here, so the hydration mismatch
 * `useId` exists to prevent cannot arise.
 */
let seed = 0;

export const useAutoId = (prefix = "planner"): string => {
  const id = useRef("");
  if (!id.current) {
    seed += 1;
    id.current = `${prefix}-${seed}`;
  }
  return id.current;
};

export default useAutoId;
